import React from 'react'
import LandingSection from '../../sections/Home/LandingSection/LandingSection'
import MintSection from '../../sections/Home/MintSection/MintSection'
import AboutUsSection from '../../sections/Home/AboutUsSection/AboutUsSection'

const HomePage = () => {
  return (
    <div>
      <LandingSection />
      <MintSection />
      <AboutUsSection />
    </div>
  )
}

export default HomePage
